import React from 'react'
import { Helmet } from 'react-helmet-async'
import UserManagementLayout from '../../layouts/Users/UserManagementLayout'

const UserPage = (): React.ReactElement => (
  <React.Fragment>
    <Helmet>
      <title>Users</title>
      <meta name="description" content="User Management page" />
    </Helmet>
    <UserManagementLayout />
  </React.Fragment>
)

export default UserPage
